var map = {
	"./bell.png": 828,
	"./businusSchool.png": 173,
	"./businusServices.png": 174,
	"./businuslogo.png": 829,
	"./clientDashboardLogo.png": 172,
	"./comply.png": 830,
	"./home.png": 831,
	"./loading.gif": 49,
	"./logo.png": 832,
	"./profile.png": 833,
	"./protect.png": 834,
	"./tax.png": 835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;